import { useAtomValue } from 'jotai';

import { useTranslate } from '@i18n';
import { activityAtom } from '@store';
import { Button, Inline, Modal, Text } from '@ui';

type DeleteLayoutModalProps = {
    isOpen: boolean;
    layoutId: number;
    onDismiss: () => void;
    onDelete: () => void;
};

export const DeleteLayoutModal = ({ isOpen, onDismiss, onDelete, layoutId }: DeleteLayoutModalProps) => {
    const activity = useAtomValue(activityAtom);
    const activeLayoutId = activity?.layoutId;

    const t = useTranslate();
    return (
        <Modal
            title={t('layout_editor.delete_prompt.title')}
            open={isOpen}
            variant="partial"
            footer={{
                primary: (
                    <Inline>
                        <Button onClick={onDismiss} variant="secondary">
                            Cancel
                        </Button>
                        {layoutId === activeLayoutId ? (
                            <Button onClick={onDismiss} variant="primary">
                                Ok
                            </Button>
                        ) : (
                            <Button onClick={onDelete} variant="destroy">
                                Delete
                            </Button>
                        )}
                    </Inline>
                ),
            }}
            onDismiss={onDismiss}
        >
            <Text>
                {layoutId === activeLayoutId
                    ? t('layout_editor.delete_prompt.warning')
                    : t('layout_editor.delete_prompt.message')}
            </Text>
        </Modal>
    );
};
